import './styles.scss';
export const Loader: any = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
      <div className="lds-hourglass"></div>
    </div>
  );
};
